import * as React from "react";
import {
  Edit,
  TabbedForm,
  TextInput,
  SelectInput,
  ArrayInput,
  SelectArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  ReferenceArrayInput,
  required,
  number,
  email,
  useEditContext,
} from "react-admin";
import {
  CLIENT_STATUSES,
  CLIENT_CHANGE_STATUSES,
} from "@local/constants/index.js";
import { CustomToolbar, Title } from "../../shared/components/index.js";
import Merchants from "./merchants.js";

const EditStatus = () => {
  const { record } = useEditContext();

  return (
    <SelectInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      source="status"
      validate={[required()]}
      choices={Object.keys(CLIENT_STATUSES).map((status) => {
        if (record.status === CLIENT_STATUSES.disabled.name) {
          return {
            id: status,
            name: `resources.Client.source.status.${status}`,
            disabled: status === CLIENT_STATUSES.confirmed.name ? false : true,
          };
        }
        if (record.status === CLIENT_STATUSES.blocked.name) {
          return {
            id: status,
            name: `resources.Client.source.status.${status}`,
            disabled: status === CLIENT_STATUSES.active.name ? false : true,
          };
        }

        if (record.status !== CLIENT_STATUSES.blocked.name) {
          return {
            id: status,
            name: `resources.Client.source.status.${status}`,
            disabled:
              status === CLIENT_STATUSES.blocked.name ||
              status === CLIENT_STATUSES.disabled.name
                ? false
                : true,
          };
        }
      })}
    />
  );
};

const editClient = () => {
  const plugins = JSON.parse(localStorage.getItem("plugins"));
  const merchant = localStorage.getItem("name");
  const merchant_id = localStorage.getItem("id");
  const nonDefaultClientRequires = [
    plugins.datexPayment,
    plugins.datexCoupon,
    plugins.multiplePaymentGateways,
  ];

  return (
    <Edit
      title={<Title source="phone" />}
      mutationMode="pessimistic"
      redirect="show"
    >
      <TabbedForm toolbar={<CustomToolbar />}>
        <TabbedForm.Tab label="resources.Client.source.tab.basic">
          <TextInput
            helperText="youremail@gmail.com"
            inputProps={{ maxLength: 64 }}
            source="email"
            validate={[
              email(),
              (merchant === "Chipo" || merchant === "PetrolCard") && required(),
            ]}
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
          />
          <TextInput
            inputProps={{ maxLength: 64 }}
            source="first_name"
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
          />
          {(merchant === "Chipo" || merchant === "PetrolCard") && (
            <TextInput
              inputProps={{ maxLength: 64 }}
              source="middle_name"
              sx={{
                width: "20%",
                "@media (max-width:900px)": {
                  width: "100%",
                },
              }}
            />
          )}
          <TextInput
            inputProps={{ maxLength: 64 }}
            source="last_name"
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
          />
          <TextInput
            helperText="380000000000"
            inputProps={{ maxLength: 12 }}
            source="phone"
            validate={[required(), number()]}
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
          />
          {plugins &&
            nonDefaultClientRequires.some((plugin) => plugin === true) &&
            Merchants[merchant].EditClient(merchant_id)}
          {nonDefaultClientRequires.every((plugin) => plugin === false) && (
            <>
              <ReferenceInput
                sx={{
                  width: "20%",
                  "@media (max-width:900px)": {
                    width: "100%",
                  },
                }}
                source="category_id"
                reference="Category"
                filter={{
                  merchant_id: merchant_id,
                }}
              >
                <SelectInput
                  sx={{
                    width: "20%",
                    "@media (max-width:900px)": {
                      width: "100%",
                    },
                  }}
                  optionText="name"
                  optionValue="id"
                />
              </ReferenceInput>
              <ReferenceArrayInput
                source="tag_ids"
                reference="Tag"
                filter={{
                  merchant_id: merchant_id,
                }}
                FormControlProps={{
                  sx: {
                    width: "44%",
                    "@media (max-width:900px)": {
                      width: "100%",
                    },
                  },
                }}
              >
                <SelectArrayInput
                  sx={{
                    width: "20%",
                    "@media (max-width:900px)": {
                      width: "100%",
                    },
                  }}
                  optionText="name"
                  optionValue="id"
                  FormControlProps={{
                    sx: {
                      width: "44%",
                      "@media (max-width:900px)": {
                        width: "100%",
                      },
                    },
                  }}
                />
              </ReferenceArrayInput>
            </>
          )}
          {plugins.datexCoupon ? (
            <EditStatus />
          ) : (
            <SelectInput
              sx={{
                width: "20%",
                "@media (max-width:900px)": {
                  width: "100%",
                },
              }}
              source="status"
              validate={[required()]}
              choices={Object.keys(CLIENT_STATUSES).map((status) => {
                if (status === CLIENT_STATUSES.active.name) {
                  return "";
                }
                return {
                  id: status,
                  name: `resources.Client.source.status.${status}`,
                };
              })}
            />
          )}
          <SelectInput
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
            source="deleted_at"
            label="resources.Client.fields.deleted_at.title"
            choices={[
              { id: "true", name: "resources.Client.fields.deleted_at.true" },
              {
                id: "false",
                name: "resources.Client.fields.deleted_at.false",
              },
            ]}
          />
        </TabbedForm.Tab>
        <TabbedForm.Tab label="resources.Client.source.tab.confirm_changes">
          <ArrayInput
            source="unconfirmed_changes"
            label="resources.Client.fields.unconfirmed_changes.name"
          >
            <SimpleFormIterator
              disableAdd
              disableRemove
              disableClear
              disableReordering
              inline
            >
              <TextInput
                source="field_name"
                disabled
                sx={{
                  width: "20%",
                  "@media (max-width:900px)": {
                    width: "100%",
                  },
                }}
              />
              <TextInput
                source="value"
                disabled
                sx={{
                  width: "20%",
                  "@media (max-width:1000px)": {
                    width: "100%",
                  },
                }}
              />
              <SelectInput
                sx={{
                  width: "20%",
                  "@media (max-width:900px)": {
                    width: "100%",
                  },
                }}
                source="status"
                validate={[required()]}
                choices={Object.keys(CLIENT_CHANGE_STATUSES).map((status) => ({
                  id: status,
                  name: `resources.Client.source.changes_status.${status}`,
                }))}
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TabbedForm.Tab>
      </TabbedForm>
    </Edit>
  );
};

export default editClient;
